/**
 * A description of `useQueryParams()`.
 */
export const useQueryParams = (): Record<string, string> => {
	return Object.fromEntries(new URLSearchParams(window.location.search));
};
